var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("event-date " + _vm.textColor)},[_c('p',{staticClass:"date-range"},[_vm._v(_vm._s(_vm.dateRange))]),(_vm.enableCountdown && _vm.started)?_c('p',{staticClass:"countdown"},[_vm._v(_vm._s(_vm.duration))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }